export default "__VITE_ASSET__1ec22cba__"